import { render, staticRenderFns } from "./SliderAbout.vue?vue&type=template&id=7f9b0c7b&scoped=true&"
import script from "./SliderAbout.vue?vue&type=script&lang=js&"
export * from "./SliderAbout.vue?vue&type=script&lang=js&"
import style0 from "./SliderAbout.vue?vue&type=style&index=0&id=7f9b0c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9b0c7b",
  null
  
)

export default component.exports